export const popoverIcons = {
    voltageSag: 'majorSags.svg',
    voltageSwell: 'swellEvents.svg',
    interruption: 'interruptions.svg',
    highFrequencyImpulse: 'hfImpulses.svg'
  };
